import { render, staticRenderFns } from "./orders-rework-properties-update.vue?vue&type=template&id=7d053776"
import script from "./orders-rework-properties-update.vue?vue&type=script&lang=js"
export * from "./orders-rework-properties-update.vue?vue&type=script&lang=js"
import style0 from "./orders-rework-properties-update.vue?vue&type=style&index=0&id=7d053776&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports